import React from 'react';
import { connect } from 'react-redux';
import { apiActions, deleteConfirmationActions } from '../../../actions';
import ConfirmationModal from '../../design/ConfirmationModal';

class DeleteConfirmation extends React.Component {
  
  okClicked = (event) => {
    event.preventDefault();
     if (!this.props.disabled) {
       this.props.commentDelete(this.props.deleteConfirmation, this.props.successMsg, this.props.cutted);
     }
  };

  cancelClicked = (event) => {
    event.preventDefault();
    this.props.deleteConfirmationClose();
  };

  render() {
    return (
      <ConfirmationModal
        title={I18n.t('common.confirmation')}
        confirm={I18n.t('common.delete')}
        cancel={I18n.t('components.story_form.cancel')}
        onConfirm={this.okClicked}
        onCancel={this.cancelClicked}
      />
    );
  }
}

const mapState = state => ({
  cutted: state.current_episode_comments.filter(c =>
    c.id === state.optionsMenu.commentedId &&
    c.comment_type === state.optionsMenu.commentedType &&
    c.pop_comment_replies_count > c.replies.length
  ).length > 0,
  deleteConfirmation: state.deleteConfirmation,
  disabled: !state.small_spinner_hidden,
  successMsg: I18n.t('components.webreader_comments_list.comment_deleted')
});

const mapDispatch = dispatch => ({
  commentDelete: (deleteConfirmation, commentDeleted) => {
    dispatch(apiActions.commentDelete(deleteConfirmation, commentDeleted));
  },
  deleteConfirmationClose: () => { dispatch(deleteConfirmationActions.deleteConfirmationClose()); }
});

export default connect(mapState, mapDispatch)(DeleteConfirmation);
